// extracted by mini-css-extract-plugin
export default {"navCover":"sidebar_navCover__fLbdk","navLinkCover":"sidebar_navLinkCover__aEZR-"};